import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import './styles.css';

class MinimalSelect extends React.Component {
  handleChange = selectedOption => {
    this.props.controlFunc(selectedOption, this.props.name);
  };

  render() {
    const { value, isSearchable, options, name, placeholder } = this.props;

    const customStyles = {
      control: base => ({
        ...base,
        boxShadow: 'none',
        borderColor: 'hsl(0,0%,80%)',
      }),
    };

    return (
      <div className="minimal-select__wrapper">
        <Select
          instanceId={Date.now()}
          value={value}
          name={name}
          styles={customStyles}
          onChange={this.handleChange}
          options={options}
          className="minimal-select"
          classNamePrefix="minimal-select"
          placeholder={placeholder}
          isSearchable={isSearchable}
        />
      </div>
    );
  }
}

MinimalSelect.defaultProps = {
  isSearchable: false,
};

MinimalSelect.propTypes = {
  options: PropTypes.array.isRequired,
  controlFunc: PropTypes.func.isRequired,
  name: PropTypes.string,
  isSearchable: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default MinimalSelect;
